import { render } from "./GenStudentID.vue?vue&type=template&id=ba14f534"
import script from "./GenStudentID.vue?vue&type=script&lang=js"
export * from "./GenStudentID.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__